import script from "./GameControls.vue?vue&type=script&setup=true&lang=js"
export * from "./GameControls.vue?vue&type=script&setup=true&lang=js"

import "./GameControls.vue?vue&type=style&index=0&id=a70a9b08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a70a9b08"]])

export default __exports__